import { Button } from '@mui/material';
import clsx from 'clsx';

import useMixpanel from '../../../hooks/useMixpanel';
import { useLoginService } from '../../../services/loginService';
import styles from './index.module.scss';

export default function GoogleButton() {
  const { trackClick } = useMixpanel();
  const { state } = useLoginService();

  return (
    <Button
      variant="contained"
      className={clsx(styles.ssoBtn, 'rounded-4')}
      onClick={() => {
        trackClick('login_with_sso');
        state.setLoginWithSso({ value: true });
      }}
    >
      Single Sign-On (SSO)
    </Button>
  );
}
